import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormGroup, FormControl } from '@angular/forms';

import {ApiService} from "../api.service";
import { HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'choose-registration',
  templateUrl: './choose-registration.component.html'
})
export class ChooseRegistrationComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

    onSubmit() {

    }

}
